<template>
  <tr class="cabinet__tbody-row">
    <td>{{ date }}</td>
    <td>{{ name }}</td>
    <td>{{ number }}</td>
    <td>{{ object }}</td>
    <td>{{ region }}</td>
    <td>{{ contragent }}</td>
    <td>
      <router-link
        :to="{ name: 'СontractDetail', params: { contractID: id } }"
        class="tooltip__list-item-img tooltip__list-item-img--show show-contract"
      />
    </td>
  </tr>
</template>

<script>

import { dateFormat } from '@/utils/helpers';

export default {
  name: 'ContractListTableItem',
  components: {},
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    id() {
      return this.item.id;
    },
    name() {
      return this.item.name;
    },
    number() {
      return this.item.number;
    },
    date() {
      return dateFormat(this.item.date);
    },
    object() {
      return this.item.objectName;
    },
    region() {
      return this.item.objectRegion;
    },
    contragent() {
      return this.item.organizationName;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.cabinet__table {
  text-align: center;

  tr th:nth-child(1),
  tr th:nth-child(3) {
    width: 10%;
  }

  tr th:nth-child(2),
  tr th:nth-child(4),
  tr th:nth-child(5),
  tr th:nth-child(6) {
    width: 20%;
  }
}

.show-contract {
  color: transparent;
  display: block;
  content: '';
  margin: 0 5px;
}
</style>
